/**
 * Fit a PDF page to the viewer pane, then apply the zoom step.
 */
export function pdfRenderScale(
  fitWidthPx: number,
  pageWidth: number,
  zoomFactor: number,
): number {
  if (pageWidth <= 0) {
    return zoomFactor;
  }
  const fitScale = Math.max(0.1, fitWidthPx / pageWidth);
  return fitScale * zoomFactor;
}

/** Inner width of the viewer pane, ignoring rendered page canvases. */
export function pdfFitWidthPx(fitElement: HTMLElement): number {
  const width = fitElement.clientWidth;
  return width > 0 ? Math.max(width - 24, 1) : 320;
}
